(ns util.core
  (:require [clojure.walk :refer [postwalk]]
            [cljs.core.match :refer-macros [match]]
            ["moment" :as moment]))

(defn transform-keys
  "Recursively transform all keys in map m with transform function t."
  [t m]
  (let [f (fn [[k v]] [(t k v) v])]
    (postwalk (fn [x] (if (map? x) (into {} (map f x)) x)) m)))

(defn long-str [& strings]
  (clojure.string/join "" strings))

(defn- guarantee-surname [name]
  (let [names (vec (clojure.string/split name #" "))]
    (if (< (count names) 2)
      (conj names "?")
      names)))

(defn abbrev-full-name-initials [name]
  (let [[fst sur] ((juxt first last) (guarantee-surname name))]
    (apply str (subs fst 0 1) " " (subs sur 0 1))))

(defn abbrev-full-name [name]
  (let [[fst sur] ((juxt first last) (guarantee-surname name))]
    (apply str fst " " (subs sur 0 1))))

(defn to-local-time
  ([iso] (to-local-time iso "MM/DD/YYYY"))
  ([iso fmt] (-> (moment iso)
                 (.format fmt))))


(defn valid-date? [ts]
  (.isValid (moment ts)))

;; This function should be used for dates that come directly from Salesforce.
;; Apparently they don't store dates with timezone information.
;; We may want to implement something upstream in the future for consistency.
(defn to-utc-time
  ([iso] (to-utc-time iso "MM/DD/YYYY"))
  ([iso fmt] (-> (moment iso)
                 (.utc)
                 (.format fmt))))

(defn to-local-year
  ([iso] (to-local-time iso "YYYY")))

(defn to-iso [ts]
  (.toISOString (moment ts)))

(defn to-input-date [ts]
  (to-local-time ts "YYYY-MM-DD"))

(defn now []
  (.format (moment)))

;; from https://gist.github.com/paultopia/78ba6791d7eba48293da45d9d5d58c57
(defn discard-nils [a b]
  (match [a b]
         [_ nil] a
         :else b))
(def safe-merge (partial merge-with discard-nils))

(defn- deep-merge* [& maps]
  (let [f (fn [old new]
            (if (and (map? old) (map? new))
              (merge-with deep-merge* old new)
              new))]
    (if (every? map? maps)
      (apply merge-with f maps)
      (last maps))))

(defn deep-merge [& maps]
  (let [maps (filter identity maps)]
    (assert (every? map? maps))
    (apply merge-with deep-merge* maps)))

(defn round-to
  "Round a double to the given precision (number of significant digits)"
  [precision d]
  (let [factor (Math/pow 10 precision)]
    (/ (Math/round (* d factor)) factor)))

(defn- no-nils
  "Filter out any [:keyword nil] entries from the given map."
  [m]
  (into {} (remove (comp nil? second)) m))

(defn trunc [s n]
  "Truncate string s to length n then append ... to the end if truncated"
  (let [number (subs s 0 (min (count s) n))]
    (if (> (count s) n)
      (str number " ...")
      number)))

(defn get-path-with-query
  ([] (get-path-with-query js/location))
  ([location] (str (.-pathname location) (.-search location))))

(defn un-edgify
  "GraphQL pagination forces us to be stupid. Unwrap the nodes and edges
  construct into a meaningful list of entities."
  [k v init coll]
  (reduce (fn [m x] (assoc-in m [v (get-in x [:node :id])] (:node x)))
          init
          (get-in coll [k :edges])))

(defn un-edgify2
  "Like un-edgify, but less implementation specific. Given a kw and the entity
  containing edges, returns the entity with the edges kw removed and placed into
  a sequence under the given kw."
  [new-kw entity]
  (assoc (dissoc entity :edges) new-kw (reduce (fn [acc v] (conj acc (:node v))) [] (:edges entity))))

(defn parse-float
  "Convert a string to its float representation, or js/NaN."
  [s]
  (.parseFloat js/Number s))

(defn string->float
  "Convert a string to its float representation, or 0 if unparseable (for cases
  such as the empty string)."
  [s]
  (let [f (parse-float s)]
    (if (.isNaN js/Number f)
      0
      f)))
